import httpClient from '~/http';
import { UserFormValues, UserItem } from '../types';

const getUsers = () => {
  return httpClient.get<{ users: UserItem[] }>('/api/v2/users');
};

const getUserById = (id: string) => {
  return httpClient.get<UserItem>(`/api/v2/users/${id}`);
};

const createUser = (body: UserFormValues) => {
  return httpClient.post<{ userId: string }>('/api/v2/users', body);
};

const updateUser = (id: string, body: UserFormValues) => {
  return httpClient.patch(`/api/v2/users/${id}`, body);
};

const updateUserPin = (id: string, body: { newPin: string }) => {
  return httpClient.patch(`/api/v2/users/${id}/pin`, body);
};

export default {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  updateUserPin,
};
